import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { Avatar, AvatarComponent } from '../avatar';

@Component({
  selector: 'pp-user-card-small',
  imports: [AvatarComponent],
  templateUrl: './user-card-small.component.html',
  styleUrl: './user-card-small.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserCardSmallComponent {
  readonly caption = input<string>();
  readonly label = input<string>();
  readonly avatar = input<Avatar>();
  readonly onlyAvatar = input<boolean>();
}
